'use strict';
var UA = require('../internals/environment-user-agent');

module.exports = /MSIE|Trident/.test(UA);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/environment-is-ie-or-edge.js
// module id = 310
// module chunks = 0